import { render, staticRenderFns } from "./CustomersClub.vue?vue&type=template&id=63cc914a&scoped=true"
import script from "./CustomersClub.vue?vue&type=script&lang=js"
export * from "./CustomersClub.vue?vue&type=script&lang=js"
import style0 from "./CustomersClub.vue?vue&type=style&index=0&id=63cc914a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cc914a",
  null
  
)

export default component.exports